export interface SitemapNestedResponseDto {
  id: number;
  title: string;
  icon?: string;
  showInTopNav?: boolean;
  topNavSequence?: number;
  topNavIcon?: string;
  bgColor?: string;
  itemClass?: string;
  path?: string;
  languageLabel: string;
  active: boolean;
  parentId?: number;
  depth: number;
  sequence: number;
  billingProductId?: number;
  newWindow: boolean;
  children?: SitemapNestedResponseDto[];
}
